import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'

// 登陆注册
import Login from "@/view/login/index";

// 卡券绑定
import cardbind from "@/view/cardbind/index";

// 观影模块
import MovieList from "@/view/movielist/index";

// 过期卡券
import cardexpirelist from "@/view/cardexpirelist/index";

// 我的卡包
import cardlist from "@/view/cardlist/index";

// 实名观影
import realName from "@/view/realname/index";

// 新增收货地址
import addAddress from "@/view/address/index";

// 基本信息
import infoIndex from "@/view/info/index";

// 基本信息
import cardEdit from "@/view/cardedit/index";

// 电影人列表
import filmmakerList from "@/view/filmmaker/index";

// 观影人列表
import contactList from "@/view/contactlist/index";

// 选择观影人
import choiceContact from "@/view/choiceContact/index";

// 选择卡券
import cardlogin from "@/view/cardlogin/index";

// 我的二维码卡列表
import qrcodeCardList from "@/view/qrcodecardlist/index";

// 我的二维码登录
import wxlogin from "@/view/wxlogin/index";

// 提货券卡登录
import giftvoucher from "@/view/giftvoucher/index";

// PC登录
import weblogin from "@/view/weblogin/index";

// 手机扫描登录
import waplogin from "@/view/waplogin/index";

// 手机扫描登录
import waploginback from "@/view/waploginback/index";

// PC用户中心-卡登录列表
import webcardlogin from "@/view/webcardlogin/index";

// PC用户中心-卡绑定
import webcardbind from "@/view/webcardbind/index";

// PC用户中心-用户信息
import webinfo from "@/view/webinfo/index";

// PC用户中心-实名认证
import webcontactlist from "@/view/webcontactlist/index";

// //H5 手机绑定页面
import activitycardlogin from '@/view/activitycardlogin/index'

// //H5 卡登录页面
import activitycardloginList from '@/view/activitycardloginList/index'

/** ================================== */

// 新业务 H5 手机绑定页面
import h5cardlogin from '@/view/h5cardlogin/index'

// 新业务 小程序 手机号修改页面
import wxcardlogin from '@/view/wxcardlogin/index'

// 新业务 H5 卡登录列表(查询有效卡列表)
import h5cardloginlist from '@/view/h5cardloginlist/index'

// h5 绑定卡页面(包括电影)--------------------------------------------------
import h5webcardbind from '@/view/h5webcardbind/index'


// 新业务 H5 地址
import h5address from '@/view/h5address/index'

// 新业务 H5 地址列表
import h5addressList from '@/view/h5addressList/index'


// 美团 增加 卡绑定页面 --------------------------------------------------
import activitycardBind from '@/view/activitycardBind/index'

// h5 个人信息页面
import h5info from '@/view/h5info/index'

// H5 统一code登录页面
import unifiedBind from '@/view/unifiedBind/index'

// H5 统一 绑定卡页面
import unifiedBindCard from '@/view/unifiedBindCard/index'

// 微信扫码绑定页面
import wxcardbind from "@/view/wxcardbind/index"

// 找销微信扫码绑定页面
import zxwxcardbind from "@/view/zxwxcardbind/index"

// 找销小程序卡绑定页面
import zxcardbind from "@/view/zxcardbind/index"

// H5 我的页面
import my from '@/view/my/index'

// 公众号虎卡登录列表页面
import tigerCardLoginList from "@/view/tigerCardLoginList/index"

// 公众号绑定虎卡页面
import tigerCardBind from "@/view/tigerCardBind/index"

// 跳转盲盒页面
import blindBox from "@/view/blindBox/index"

// 手机号注册
import mobileLogin from "@/view/mobileLogin/index"

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "choiceContact",
      component: choiceContact,
      meta: {
        title: "选择观影人"
      }
    },

    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录"
      }
    },
    {
      path: "/cardbind",
      name: "cardbind",
      component: cardbind,
      meta: {
        title: "新卡券"
      }
    },
    {
      path: "/movielist",
      name: "movieList",
      component: MovieList,
      meta: {
        title: "观影列表"
      }
    },
    {
      path: "/expirecard",
      name: "expireCard",
      component: cardexpirelist,
      meta: {
        title: "过期卡券"
      }
    },
    {
      path: "/cardlist",
      name: "cardlist",
      component: cardlist,
      meta: {
        title: "我的卡包"
      }
    },
    {
      path: "/realname",
      name: "realName",
      component: realName,
      meta: {
        title: "实名观影"
      }
    },
    {
      path: "/address",
      name: "addAddress",
      component: addAddress,
      meta: {
        title: "新增收货地址"
      }
    },
    {
      path: "/info",
      name: "infoIndex",
      component: infoIndex,
      meta: {
        title: "基本信息"
      }
    },
    {
      path: "/cardedit",
      name: "cardedit",
      component: cardEdit,
      meta: {
        title: "卡券操作"
      }
    },
    {
      path: "/filmmaker",
      name: "filmmakerList",
      component: filmmakerList,
      meta: {
        title: "卡券操作"
      }
    },
    {
      path: "/contactlist",
      name: "contactList",
      component: contactList,
      meta: {
        title: "常用联系人列表"
      }
    },

    {
      path: "/cardlogin",
      name: "cardlogin",
      component: cardlogin,
      meta: {
        title: "卡登陆"
      }
    },

    {
      path: "/qrcodecardlist",
      name: "qrcodecardlist",
      component: qrcodeCardList,
      meta: {
        title: "我的卡列表"
      }
    },
    {
      path: "/wxlogin",
      name: "wxlogin",
      component: wxlogin,
      meta: {
        title: "微信登录授权"
      }
    },
    {
      path: "/giftvoucher",
      name: "giftvoucher",
      component: giftvoucher,
      meta: {
        title: "提货券卡登录"
      }
    },
    {
      path: "/weblogin",
      name: "weblogin",
      component: weblogin,
      meta: {
        title: "用户中心登录"
      }
    },
    {
      path: "/waplogin",
      name: "waplogin",
      component: waplogin,
      meta: {
        title: "用户中心登录"
      }
    },
    {
      path: "/waploginback",
      name: "waploginback",
      component: waploginback,
      meta: {
        title: "用户中心登录"
      }
    },
    {
      path: "/webcardlogin",
      name: "webcardlogin",
      component: webcardlogin,
      meta: {
        title: "用户中心-web卡登录"
      }
    },
    {
      path: "/webcardbind",
      name: "webcardbind",
      component: webcardbind,
      meta: {
        title: "用户中心-web卡绑定"
      }
    },
    {
      path: "/webinfo",
      name: "webinfo",
      component: webinfo,
      meta: {
        title: "用户中心-web个人信息"
      }
    },
    {
      path: "/webcontactlist",
      name: "webcontactlist",
      component: webcontactlist,
      meta: {
        title: "用户中心-web实名认证"
      }
    },
    {
      path: "/activitycardlogin",
      name: "activitycardlogin",
      component: activitycardlogin,
      meta: { title: "手机绑定" }
    },
    {
      path: '/activitycardloginList',
      name: 'activitycardloginList',
      component: activitycardloginList,
      meta: { title: '卡登录列表' }
    },
    {
      path: "/activitycardBind",
      name: "activitycardBind",
      component: activitycardBind,
      meta: { title: "绑定新卡" }
    },
    // ------ 新加路由 --------
    {
      path: "/h5cardlogin",
      name: "h5cardlogin",
      component: h5cardlogin,
      meta: { title: "手机绑定" }
    },
    {
      path: "/wxcardlogin",
      name: "wxcardlogin",
      component: wxcardlogin,
      meta: { title: "手机修改" }
    },
    // ------------------- h5 (电影)
    {
      path: "/h5cardloginlist",
      name: "h5cardloginlist",
      component: h5cardloginlist,
      meta: { title: "卡登录列表" }
    },
    {
      path: "/h5webcardbind",
      name: "h5webcardbind",
      component: h5webcardbind,
      meta: { title: "新卡绑定" }
    },
     // ------------------------- h5 (电影)
    {
      path: "/h5address",
      name: "h5address",
      component: h5address,
      meta: { title: "新增收货地址" }
    },
    {
      path: "/h5addressList",
      name: "h5addressList",
      component: h5addressList,
      meta: { title: "收货地址列表" }
    },
    {
      path: "/my",
      name: "my",
      component: my,
      meta: { title: "个人中心" }
    },
    {
      path: "/h5info",
      name: "h5info",
      component: h5info,
      meta: { title: "个人信息" }
    },
    // ---------- H5 统一code登录 以及 统一绑卡页面 ----------
    {
      path: "/unifiedBind",
      name: "unifiedBind",
      component: unifiedBind,
      meta: { title: "手机号绑定" }
    },
    {
      path: "/unifiedBindCard",
      name: "unifiedBindCard",
      component: unifiedBindCard,
      meta: { title: "统一绑卡" }
    },
    {
      path: "/wxcardbind",
      name: "wxcardbind",
      component: wxcardbind,
      meta: { title: "卡绑定" }
    },
    {
      path: "/zxcardbind",
      name: "zxcardbind",
      component: zxcardbind,
      meta: { title: "卡绑定" }
    },
    {
      path: "/zxwxcardbind",
      name: "zxwxcardbind",
      component: zxwxcardbind,
      meta: { title: "新卡绑定" }
    },
    {
      path: "/tigerCardLoginList",
      name: "tigerCardLoginList",
      component: tigerCardLoginList,
      meta: { title: "虎卡登录" }
    },
    {
      path: "/tigerCardBind",
      name: "tigerCardBind",
      component: tigerCardBind,
      meta: { title: "虎卡绑定" }
    },
    {
      path: "/blindBox",
      name: "blindBox",
      component: blindBox,
      meta: { title: "盲盒" }
    },
    {
      path: "/mobileLogin",
      name: "mobileLogin",
      component: mobileLogin,
      meta: { title: "手机号注册" }
    },
  ]
  // mode: "history"
});



// WEBPACK FOOTER //
// ./src/router/index.js